import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllRoles = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.roles,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const fetchAllPermissions = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.permissions,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createRole = (data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.createRole,
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      name: data?.name,
      description: data?.description,
      permission: data?.permission?.map((item) => {
        return { id: item.id };
      }),
    },
  });
};

export const updateRole = (id, data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.role(id),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const deleteRole = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.role(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deletePermission = (roleId, permissionId) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.deletePermission(roleId, permissionId),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
